<template>
  <div class="PanelMonitoring">
    <ul>
      <li class="pm-li">
        <div class="pm-li-wt"> <el-switch size="small" v-model="isRefresh" @change="setAutoRefresh"> </el-switch> {{ $t('ctcip1') }}</div>
        <div class="pm-li-set">
          <div class="pm-li-c">
            <div class="pm-li-sensor" v-for="(s,index) in sensorList" :key="index">
              <!-- <span>{{ s.name }} : </span> -->
              <span>{{ $t(s.i18n) }} : </span>
              <span v-if="sensor[s.key] < s.critical || sensor[s.key] === undefined" style="color: #41f167;">
                {{ $t('ctcip2') }}
              </span>
              <span v-else style="color: #2fb3ff;">
                <i>{{ sensor[s.key] }}</i>
                <i>{{ s.units }}</i>
              </span>
            </div>
          </div>
          <div class="pm-li-but">
            <span></span>
            <el-button size="small" @click="getSensorInfo"> {{ $t('ctcip3') }}</el-button>
          </div>
        </div>
      </li>
      <li class="pm-li" style="height: 360px;" v-loading="cardList.loading" :element-loading-text="$t('ctcip4')">
        <div class="pm-li-wt"> {{$t('ctcip5')}} </div>
        <div class="pm-li-set">
          <div class="pm-li-c" style="height: 296px;">
            <el-table :data="cardList.RxTx" style="width: 100%" border height="100%">
              <el-table-column type="index" :label="$t('ctcip6')" width="60">
              </el-table-column>
              <el-table-column prop="type" :label="$t('ctcip7')" width="120">
              </el-table-column>
              <el-table-column prop="version" :label="$t('ctcip8')">
              </el-table-column>
            </el-table>
          </div>
          <div class="pm-li-but">
            <span></span>
            <el-button size="small" @click="getCardInfo">{{$t('ctcip9')}}</el-button>
          </div>
        </div>

      </li>
    </ul>
  </div>
</template>

<script>

const sensorList = [
  { name: "屏体温度", key: "temp", units: "°C", critical: -60, i18n: 'ctcip10' },
  { name: "屏体湿度", key: "wet", units: "%", critical: 0, i18n: 'ctcip11' },
  { name: "环境亮度", key: "bright", units: "lux", critical: 0, i18n: 'ctcip12' },
  { name: "烟感", key: "ppm", units: "ppm", critical: 0, i18n: 'ctcip13' },
];

export default {
  name: "PanelMonitoring",
  props: {
    currentDetail: {
      type: Object
    }
  },
  data() {
    return {
      sensor: {},
      isRefresh: false,
      clearIntervalId: null,
      sensorList,
      cardList: {
        rxCard: [],
        txCard: [],
        RxTx: [],
        loading: true
      },
    }
  },
  mounted() {
    this.init();
    this.getSensorInfo();
    this.getCardInfo();
  },
  methods: {
    init() {
      this.myWebSocket.onmessage = (val) => {
        let upresult = JSON.parse(val.data);
        if (upresult.type === "invoke_method") {
          const uri = upresult.data.uri;
          if (upresult.data.uri && upresult.data.uri === "getSensorInfo") {
            this.sensor = JSON.parse(upresult.data.response);
          }
          if (uri === "getCardInfo") {
            const { rxCardList, txCard: txCardList } = JSON.parse(upresult.data.response).data;
            let rxCard = [];
            let txCard = [txCardList];
            rxCardList.forEach((list) => { rxCard = [...rxCard, ...list]; });
            rxCard = rxCard.map((card) => ({ 'version': card.version.split('ID号')[0] }));
            const RxTx = txCard.map((item) => { item.type = "发送卡"; return item; }).concat(rxCard.map((item) => { item.type = "接收卡"; return item; })).map((rt, index) => {
              rt.key = index;
              return rt;
            })
            this.cardList = { RxTx, rxCard, txCard, loading: false };
          }
        }
      }
    },
    getCardInfo() {
      this.cardList.loading = true;
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getCardInfo", methodParams: {} } }], 'get');
    },
    getSensorInfo() {
      this.sendCmd([{ type: "invoke_method", data: { methodName: "getSensorInfo", methodParams: {} } }], 'get');
    },
    sendCmd(commands_info, type = "set") {

      this.init();

      const { id, sn, type_id, name } = this.currentDetail;
      let devices_info = [{ id, sn, type_id, name, cache: {} }];

      this.$http.post("/admin/Command/generalCommand", {
        device_select_mode: "multiple",
        devices_info: encodeURIComponent(JSON.stringify(devices_info)),
        commands_info: encodeURIComponent(JSON.stringify(commands_info)),
        request_type: type
      }, () => {
        // console.log(res);
      });
    },
    setAutoRefresh(val) {
      if (val) {
        this.clearIntervalId = setInterval(() => {
          this.getSensorInfo();
        }, 3000);
      } else {
        clearInterval(this.clearIntervalId)
      }
    },
  },
  computed: {
    myWebSocket() {
      return this.$store.getters.myWebSocket;
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.clearIntervalId);
  },
}
</script>

<style lang="scss" scoped>
.PanelMonitoring {
  width: 100%;
  height: 100%;
  ul {
    padding: 32px;
    .pm-li {
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      border-bottom: 1px solid #d7ecf3;
      .pm-li-set {
        display: flex;
        padding-left: 32px;
      }
      .pm-li-c {
        width: calc(100% - 140px);
        display: flex;
        align-items: center;
        .pm-li-sensor {
          margin-right: 32px;
        }
      }
      .pm-li-but {
        width: 140px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
.PanelMonitoringForm {
  width: 20%;
  height: 20%;
  margin-top: 5%;
  margin-left: 5%;
  .FormInfo {
    width: 100%;
    height: 10%;
    color: red;
    margin-left: 40px;
  }
}
.PanelMonitoringFormDown {
  width: 20%;
  height: 20%;
  margin-top: 5%;
  margin-left: 5%;
}
.PanelMonitoringDown {
  width: 20%;
  height: 20%;
  margin-top: 5%;
  margin-left: 5%;
}
</style>
